<template>
    <ExtendedLayout
        :project="project"
        currentTab="realtors"
    >

        <Panel>

            <form @submit.prevent="submit">

                <ProjectFeedSelector
                    v-if="project.type === 'multi_feed'"
                    :project="project"
                    @select="selectedFeedId = $event"
                />

                <div class="flex items-center justify-between gap-6 border-b border-gray-200 pb-5 mb-5">
                    <label class="flex-shrink-0 font-medium">{{ __('admin::labels.add_realtor') }}:</label>
                    <VueMultiselect
                        :options="realtorOptions"
                        :placeholder="__('admin::labels.search')"
                        label="name"
                        @select="addRealtor"
                    />
                </div>

                <Draggable
                    :list="form.realtors"
                    as="div"
                    class="grid grid-cols-2 gap-4 mb-8"
                    item-key="realtor_id"
                >

                    <template #item="{element}">
                        <div class="flex w-full bg-white border border-gray-200 rounded-md shadow-sm cursor-move" v-if="element.project_feed_id === selectedFeedId">
                            <div class="w-48 aspect-[4/3] rounded-l-md bg-gray-200">
                                <img class="w-full h-full object-cover rounded-l-md" :src="realtor(element).public_path" alt="" v-if="realtor(element).public_path" />
                            </div>
                            <div class="flex-grow p-4">
                                <div class="text-lg font-bold">{{ realtor(element).name }}</div>
                                <div class="mt-2">{{ __('admin::labels.email') }}: {{ realtor(element).email }}</div>
                                <div class="mt-1">{{ __('admin::labels.phone') }}: {{ realtor(element).phone }}</div>
                                <button type="button" class="mt-3 text-sm text-red-600 cursor-pointer" @click="deleteRealtor(element.realtor_id)">
                                    {{ __('admin::labels.delete') }}
                                </button>
                            </div>
                        </div>
                    </template>

                </Draggable>

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::projects.project').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import {RefreshIcon} from "@heroicons/vue/outline";
import Button from "@/Components/Button";
import VueMultiselect from 'vue-multiselect'
import Draggable from 'vuedraggable';

import 'vue-multiselect/dist/vue-multiselect.css';
import ProjectFeedSelector from "@/Components/ProjectFeedSelector";

export default {
    components: {
        ProjectFeedSelector,
        Button,
        Draggable,
        Panel,
        ExtendedLayout,
        RefreshIcon,
        VueMultiselect,
    },
    props: {
        errors: Object,
        project: Object,
        realtorOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                realtors: this.project.realtors.map((x) => {
                    return {
                        project_feed_id: x.pivot.project_feed_id,
                        realtor_id: x.id,
                    };
                }),
            }),
            selectedFeedId: null,
        }
    },
    computed: {
        editableRealtors() {
            return this.form.realtors.filter((x) => x.project_feed_id === this.selectedFeedId);
        },
    },
    methods: {
        realtor(item) {
            return this.realtorOptions.find((x) => x.id === item.realtor_id);
        },
        addRealtor(realtor) {
            if (! this.editableRealtors.find((x) => x.realtor_id === realtor.id)) {
                this.form.realtors.push({
                    project_feed_id: this.selectedFeedId,
                    realtor_id: realtor.id,
                });
            }
        },
        deleteRealtor(realtorId) {
            const index = this.form.realtors.findIndex((x) => x.realtor_id === realtorId && x.project_feed_id === this.selectedFeedId);
            this.form.realtors.splice(index, 1);
        },
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.realtors.update', { project: this.project.id }));
        }
    },
}
</script>

<style>
.multiselect {
    font-family: 'Montserrat', sans-serif;
}

.multiselect__input {
    padding-top: 2px;
    padding-bottom: 3px;
    padding-left: 0;
    font-size: 14px;
}

.multiselect__input:focus {
    box-shadow: none !important;
}

.multiselect__option--highlight, .multiselect__option--highlight::after {
    background: #efefef;
    color: #000;
}
</style>
